import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'shared-core-table-body',
  template: ` <ng-content /> `,
})
export class TableBodyRowsComponent {
  @HostBinding('class')
  class = 'contents';
}
